export class ResultDto {
  result: string

  static create() {
    return new ResultDto()
  }
}


export class ResultSyncDto {
  result: boolean

  static create() {
    return new ResultSyncDto()
  }
}
